import type { SVGProps } from 'react';

const SvgHomeFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M10.9258 3.31926C11.5809 2.89358 12.4191 2.89358 13.0742 3.31926L20.0742 7.86707C20.651 8.2419 21 8.89202 21 9.59008V18.9579C21 20.0857 20.1046 21 19 21H5C3.89543 21 3 20.0857 3 18.9579V9.59008C3.00005 8.89202 3.34904 8.2419 3.92578 7.86707L10.9258 3.31926ZM8 15.129C7.58585 15.129 7.2501 15.472 7.25 15.8948C7.25 16.3177 7.58579 16.6606 8 16.6606H16C16.4142 16.6606 16.75 16.3177 16.75 15.8948C16.7499 15.472 16.4142 15.129 16 15.129H8Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgHomeFilled;
